import {z} from 'zod';

import {reportFiltersSchema} from './ReportFiltersSchema';

export const averageOrderPriceByMonthSchema = z.object({
  month: z.string(),
  labourAverage: z.number(),
  materialAverage: z.number(),
  dmmAverage: z.number(),
  totalAverage: z.number(),
  orderCount: z.number(),
});

export type AverageOrderPriceByMonth = z.infer<typeof averageOrderPriceByMonthSchema>;

export const averageOrderPriceSummarySchema = averageOrderPriceByMonthSchema.omit({month: true});

export type AverageOrderPriceSummary = z.infer<typeof averageOrderPriceSummarySchema>;

export const averageOrderPriceByMonthResponseSchema = z.object({
  data: z.array(averageOrderPriceByMonthSchema),
  summary: averageOrderPriceSummarySchema,
  filters: reportFiltersSchema,
});

export type AverageOrderPriceByMonthResponse = z.infer<
  typeof averageOrderPriceByMonthResponseSchema
>;
